/* @jsx jsx */
import { jsx } from '@emotion/react';
import { useRef } from 'react';
import { suggestionsGroupHeadingStyles } from './styles';
/**
 * While this component is a simple heading, it's been integrated in case
 * future needs require it to be more complex.
 */
export const ListHeading = ({
  heading
}) => {
  const listHeadingRef = useRef(null);
  return jsx("li", {
    css: suggestionsGroupHeadingStyles,
    ref: listHeadingRef
  }, jsx("h3", {
    "data-testid": heading
  }, heading));
};